"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lcHttp = _interopRequireDefault(require("lc-http"));
var _classnames = _interopRequireDefault(require("classnames"));
var _disclosures = _interopRequireDefault(require("./disclosures"));
var _brands = _interopRequireDefault(require("./brands"));
var _printView = require("./print-view");
var _products = require("./products");
var _amount2 = require("./amount");
var _validateAmount = _interopRequireDefault(require("../validateAmount"));
var _practices = require("./practices");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DEFAULT_AMOUNT = 1;
var Main = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Main, _Component);
  var _super = _createSuper(Main);
  function Main() {
    var _this;
    (0, _classCallCheck2.default)(this, Main);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isCalcSubmitted: false,
      brand: _this.props.brand,
      clientId: _this.props.clientId,
      amount: _this.props.amount,
      model: {
        products: _this.props.products,
        clientInfo: _this.props.clientInfo
      },
      validationError: false,
      validationMessage: '',
      isInitialLoad: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isGroupOrCorp", ['group', 'corporation'].includes(_this.props.orgType));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollToBrands", function () {
      var _window;
      var formContainer = document.querySelector('.form-container');
      if (!((_window = window) !== null && _window !== void 0 && _window.scrollTo)) {
        formContainer.scrollIntoView();
        return;
      }
      var y = formContainer.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClick", function (e) {
      var that = (0, _assertThisInitialized2.default)(_this);
      var _this$props = _this.props,
        fetchProductsUrl = _this$props.fetchProductsUrl,
        onClick = _this$props.onClick,
        additionalParams = _this$props.additionalParams,
        mobileMode = _this$props.mobileMode;
      var _that$state = that.state,
        amount = _that$state.amount,
        clientId = _that$state.clientId;
      var products = _this.state.model.products;
      if (products && products.length === 0 || amount <= 1) {
        return e.preventDefault();
      }
      if (clientId) {
        // Overwrite the clientId for corp/group with the clientId of selected practice
        additionalParams.clientId = clientId;
      }
      var validationMessage = (0, _validateAmount.default)(amount, products);
      if (!validationMessage) {
        var _this$state = _this.state,
          _amount = _this$state.amount,
          brand = _this$state.brand;
        _lcHttp.default.get(fetchProductsUrl, {
          params: _objectSpread({
            amount: _amount,
            brand: brand
          }, additionalParams)
        }).then(function (_ref) {
          var model = _ref.data;
          that.setState({
            model: model,
            validationError: false,
            isInitialLoad: false,
            isCalcSubmitted: true
          });
          if (typeof onClick === 'function') that.props.onClick();
          if (mobileMode) {
            _this.scrollToBrands();
          }
        }).catch(console.log);
      } else {
        that.setState(_objectSpread(_objectSpread({}, that.state), {}, {
          validationError: true,
          validationMessage: validationMessage,
          isInitialLoad: true,
          isCalcSubmitted: false
        }), function () {
          that.fetchPlans();
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPrintClick", function (e) {
      var _this$state2 = _this.state,
        amount = _this$state2.amount,
        brand = _this$state2.brand,
        clientId = _this$state2.clientId;
      var onPrint = _this.props.onPrint;
      onPrint(e, {
        amount: amount,
        brand: brand,
        clientId: clientId
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBrandSelect", function (e) {
      var brand = e.target.value;
      _this.setState({
        brand: brand
      }, function () {
        _this.fetchPlans();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTextChange", function (amount) {
      _this.setState({
        amount: amount
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPracticeChange", function (clientId) {
      // Set the selected clientId in state
      _this.setState({
        clientId: clientId
      }, function () {
        _this.fetchPlans();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGroupChange", function () {
      _this.setState({
        model: {
          products: _this.props.products
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchPlans", function () {
      var that = (0, _assertThisInitialized2.default)(_this);
      var _this$props2 = _this.props,
        fetchPlansUrl = _this$props2.fetchPlansUrl,
        onClick = _this$props2.onClick;
      var _this$state3 = _this.state,
        brand = _this$state3.brand,
        clientId = _this$state3.clientId;
      _lcHttp.default.get(fetchPlansUrl, {
        params: {
          brand: brand,
          clientId: clientId,
          type: 'practice'
        }
      }).then(function (_ref2) {
        var model = _ref2.data;
        that.setState({
          model: model
        });
        if (typeof onClick === 'function') that.props.onClick();
      }).catch(console.log);
    });
    return _this;
  }
  (0, _createClass2.default)(Main, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        brands = _this$props3.brands,
        calculationText = _this$props3.calculationText,
        mobileMode = _this$props3.mobileMode,
        printMode = _this$props3.printMode,
        className = _this$props3.className,
        showEmpty = _this$props3.showEmpty,
        constants = _this$props3.constants,
        placeholder = _this$props3.placeholder,
        orgType = _this$props3.orgType,
        groupOrCorpClients = _this$props3.groupOrCorpClients,
        isMedicalMarket = _this$props3.isMedicalMarket,
        pageIntro = _this$props3.pageIntro,
        applyNow = _this$props3.applyNow,
        goBack = _this$props3.goBack,
        showNavBar = _this$props3.showNavBar,
        clientId = _this$props3.clientId,
        isInnerCalculator = _this$props3.isInnerCalculator;
      var hasBrands = brands && !!brands.length;
      var hasSelectedBrand = clientId || hasBrands && brands.find(function (brand) {
        return brand.selected;
      });
      var _this$state4 = this.state,
        model = _this$state4.model,
        validationError = _this$state4.validationError,
        validationMessage = _this$state4.validationMessage,
        amount = _this$state4.amount,
        isCalcSubmitted = _this$state4.isCalcSubmitted,
        isInitialLoad = _this$state4.isInitialLoad;
      var rootClasses = (0, _classnames.default)(className, {
        'col-xs-12 col-md-10 col-md-offset-1': true,
        'payment-calculator-component': true,
        'container-fluid': true,
        'inner-pcalculator': isInnerCalculator,
        'payment-calculator-component--print': printMode
      });
      var inputClasses = _classnames.default.apply(void 0, ['form__amount', {
        'field-error': validationError
      }]);
      var topBarClasses = _classnames.default.apply(void 0, [{
        'row': true,
        'action-top-bar': true,
        'hide': !showNavBar
      }]);
      var isCTADisabled = model.products && model.products.length === 0 || amount <= 1;
      var validation = validationError && /*#__PURE__*/_react.default.createElement("div", {
        className: "field-error-msg"
      }, validationMessage);
      var brandsDropdown = hasBrands && !hasSelectedBrand && /*#__PURE__*/_react.default.createElement(_brands.default, Object.assign({}, this.props, {
        className: "form-group col-xs-12 col-sm-4 col-md-5",
        onChange: this.onBrandSelect
      }));
      var practices = this.isGroupOrCorp && /*#__PURE__*/_react.default.createElement(_practices.Practices, {
        groupOrCorpClients: groupOrCorpClients,
        orgType: orgType,
        fetchPlans: this.onPracticeChange,
        onGroupChange: this.onGroupChange,
        isMedicalMarket: isMedicalMarket
      });
      if (printMode) {
        return /*#__PURE__*/_react.default.createElement(_printView.PrintView, Object.assign({}, this.props, {
          className: rootClasses,
          model: model
        }));
      }
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: topBarClasses
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "back-wrapper col-xs-12 col-sm-6"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn-back",
        onClick: goBack,
        "aria-label": "Patient Solutions"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "back-arrow"
      }), /*#__PURE__*/_react.default.createElement("span", null, "Patient Solutions"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "cta-section col-sm-6"
      }, /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": "apply-now-cta",
        className: "btn-cta",
        onClick: applyNow,
        "aria-label": "Apply Now"
      }, "Apply Now"))), /*#__PURE__*/_react.default.createElement("div", {
        className: rootClasses
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "heading"
      }, "Payment Calculator"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row intro-page"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("p", null, pageIntro))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row form-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form col-xs-12"
      }, this.isGroupOrCorp && /*#__PURE__*/_react.default.createElement("div", {
        className: "form__label row"
      }, "Select your ", "".concat(orgType === 'corporation' ? 'group and ' : ''), "".concat(isMedicalMarket ? 'practice' : 'center'), " to display available options"), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('form__action row', {
          'form-field-error': validationError
        })
      }, brandsDropdown, practices, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group col-xs-12 col-sm-4 col-md-4"
      }, /*#__PURE__*/_react.default.createElement(_amount2.AmountField, {
        placeholder: placeholder,
        className: inputClasses,
        onChange: this.onTextChange,
        onEnterKeyPress: this.onClick
      }), validation), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group col-xs-12 col-sm-4 col-md-3"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "buttons-row row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-9 lg-10"
      }, /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": "calculate-button",
        className: "form__calculate",
        disabled: isCTADisabled,
        onClick: this.onClick
      }, calculationText)), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-3 lg-2"
      }, /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": "print-button",
        className: "form__print",
        disabled: isInitialLoad && !isCalcSubmitted,
        onClick: this.onPrintClick,
        "aria-label": "Print"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "print-icon"
      })))))))), /*#__PURE__*/_react.default.createElement(_products.ProductCategory, Object.assign({}, model, {
        mobileMode: mobileMode,
        showEmpty: showEmpty,
        constants: constants,
        isLoggedIn: this.props.isLoggedIn,
        isMedicalMarket: isMedicalMarket
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cta-section bottom col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn-cta",
        onClick: applyNow
      }, "Apply Now"))), /*#__PURE__*/_react.default.createElement(_disclosures.default, Object.assign({
        className: "row"
      }, this.props, {
        products: model.products
      }))));
    }
  }]);
  return Main;
}(_react.Component);
Main.defaultProps = {
  brand: 'DENTAL',
  amount: DEFAULT_AMOUNT,
  products: [],
  clientInfo: null,
  showEmpty: true,
  additionalParams: {},
  isLoggedIn: false,
  isMedicalMarket: false
};
Main.propTypes = {
  isInnerCalculator: _propTypes.default.bool,
  additionalParams: _propTypes.default.object,
  amount: _propTypes.default.number,
  brand: _propTypes.default.string,
  clientId: _propTypes.default.string,
  brands: _propTypes.default.arrayOf(_propTypes.default.object),
  calculationText: _propTypes.default.string,
  className: _propTypes.default.string,
  clientInfo: _propTypes.default.object,
  constants: _propTypes.default.object,
  disclosureContent: _propTypes.default.arrayOf(_propTypes.default.object),
  fetchProductsUrl: _propTypes.default.string,
  mobileMode: _propTypes.default.bool,
  navigation: _propTypes.default.shape({
    text: _propTypes.default.string,
    className: _propTypes.default.string,
    onClick: _propTypes.default.func
  }),
  organization: _propTypes.default.string,
  printMode: _propTypes.default.bool,
  products: _propTypes.default.arrayOf(_propTypes.default.object),
  requestedAmount: _propTypes.default.string,
  showEmpty: _propTypes.default.bool,
  siteUrl: _propTypes.default.string,
  onClick: _propTypes.default.func,
  goBack: _propTypes.default.func,
  applyNow: _propTypes.default.func,
  pageIntro: _propTypes.default.string,
  onPrint: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  groupOrCorpClients: _propTypes.default.object,
  orgType: _propTypes.default.string,
  fetchPlansUrl: _propTypes.default.string,
  isLoggedIn: _propTypes.default.bool,
  isMedicalMarket: _propTypes.default.bool,
  showNavBar: _propTypes.default.bool
};
var _default = Main;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-payment-calculator/dist/client/components/scss/index.scss');